import { dataDailog } from "./../../../review-activities/review-table/review-activity.module";
import { take } from "rxjs/operators";
import { Subscription } from "rxjs";
import { Component, OnInit, AfterViewChecked } from "@angular/core";
import { ThemePalette } from "@angular/material/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { CommonService } from "src/app/services/common.service";
import { ProgressSpinnerMode } from "@angular/material/progress-spinner";
import { ResponsiveService } from "src/app/services/responsive.service";
import { AdminPortalService } from "../../service/admin-portal.service";
import { MatDialog } from "@angular/material/dialog";
import { DowntimeModalComponent } from "../downtime-modal/downtime-modal.component";
import { DowntimeConfirmationModalComponent } from "../downtime-confirmation-modal/downtime-confirmation-modal.component";
import { DatePipe } from "@angular/common";
import { RedemptionDowntimeData } from "src/app/shared/models/admin-portal.model";
import { ConfirmationModalComponent } from "src/app/shared/components/confirmation-modal/confirmation-modal.component";
@Component({
  selector: "app-main-section",
  templateUrl: "./main-section.component.html",
  styleUrls: ["./main-section.component.css"],
  providers: [DatePipe],
})
export class MainSectionComponent implements OnInit, AfterViewChecked {
  mobile: boolean;
  allotmentTypeForm!: UntypedFormGroup;
  amountDistribution: number;
  amountRedeem: number;
  availablePercent: number;
  amountLeft: number;
  amountExpired: number;
  usedPercent: number;
  expiredPercent: number;
  geminiWalletAmount: number;
  storeData: boolean;
  value: number;
  color: ThemePalette;
  mode: ProgressSpinnerMode;
  disableAddNew: boolean;
  scheduleDowntime: boolean;
  downtimeData: RedemptionDowntimeData;
  endDowntime: boolean;
  constructor(
    public commonService: CommonService,
    private formBuilder: UntypedFormBuilder,
    private _responsiveService: ResponsiveService,
    private adminPortalService: AdminPortalService,
    private dialog: MatDialog,
    private datePipe: DatePipe
  ) {
    this.mobile = false;
    this.allotmentTypeForm = this.formBuilder.group({});
    this.amountDistribution = 0;
    this.amountLeft = 0;
    this.amountExpired = 0;
    this.amountRedeem = 0;
    this.usedPercent = 0;
    this.availablePercent = 0;
    this.expiredPercent = 0;
    this.geminiWalletAmount = 0;
    this.value = 50;
    this.storeData = false;
    this.color = "primary";
    this.mode = "indeterminate";
    this.disableAddNew = false;
    this.commonService.getUpdate().subscribe((message) => {
      this.getRewardDistribution();
    });
    this.scheduleDowntime = false;
    this.endDowntime = false;
    this.downtimeData = {
      redemptionDowntimeStatus: false,
      redemptionDowntimeDetails: {
        fromDate: new Date()
      },
    };
  }
  ngOnInit(): void {
    this.onResize();
    this.commonService.setBudgetAddBtnClicked(false);
    this.commonService.setAdminPortalOpened(true);
    this.allotmentTypeForm = this.formBuilder.group({
      allotmentData: [""],
    });
    this.commonService.setBudgetAddBtnClicked(false);
    this.getGeminiWalletAmount();
    this.adminPortalService.isJobRunning$.subscribe((isJobRunning) => {
      this.disableAddNew = isJobRunning;
    });
    this.adminPortalService
      .getIsJobRunning()
      .subscribe((isJobRunning: String) => {
        this.disableAddNew = isJobRunning === "TRUE" ? true : false;
      });
    this.getRedemptionDowntimeData();
  }

  ngAfterViewChecked(): void {
    if (!this.commonService.getBudgetAddBtnClicked())
      this.allotmentTypeForm.reset();
    this.getPercentage();
  }

  AddBtnClicked(): void {
    if (!this.disableAddNew) {
      this.commonService.setBudgetAddBtnClicked(true);
    }
  }

  isAllotmentTypeBudget(): boolean {
    return this.allotmentTypeForm.value.allotmentData === "budget";
  }

  navigateToRewardDistributionHistory(): void {
    this.commonService.setBudgetAddBtnClicked(false);
  }

  isAllotmentTypeReward(): boolean {
    return this.allotmentTypeForm.value.allotmentData === "reward";
  }

  setAllotmentTypeinService(): void {
    this.adminPortalService.setAllotmentType(
      this.allotmentTypeForm.value.allotmentData
    );
  }

  getGeminiWalletAmount(): void {
    this.adminPortalService
      .getGeminiWalletAmount()
      .pipe(take(1))
      .subscribe((data) => {
        this.geminiWalletAmount = data;
        this.storeData = true;
        this.getRewardDistribution();
      });
  }
  getRewardDistribution(): void {
    this.adminPortalService
      .getRewardAmount()
      .pipe(take(1))
      .subscribe((data) => {
        this.amountDistribution = data.totalAmountDistributedByAdmin;
        this.amountRedeem = data.totalAmountRedeemed;
        this.amountLeft = data.totalAmountLeftToRedeem;
        this.amountExpired = data.totalExpiredAmount;
      });
  }

  getRedemptionDowntimeData() {
    this.adminPortalService.getRedemptionDowntimeData().subscribe({
      next: (data) => {
        this.downtimeData = data;
        if (this.downtimeData.redemptionDowntimeStatus) {
          this.endDowntime = true;
          this.scheduleDowntime = false;
        } else if (
          new Date(
            this.downtimeData.redemptionDowntimeDetails?.fromDate
          ).getTime() > Date.now() &&
          (this.downtimeData.redemptionDowntimeDetails?.toDate ==
            null ||
            new Date(
              this.downtimeData.redemptionDowntimeDetails?.toDate
            )?.getTime() > Date.now())
        ) {
          this.endDowntime = false;
          this.scheduleDowntime = false;
        } else {
          this.scheduleDowntime = true;
          this.endDowntime = false;
        }
      },
      error: (e) => {
        console.log(e);
      },
    });
  }

  getPercentage() {
    if (this.amountDistribution != 0) {
      this.usedPercent = Number(
        (((this.amountRedeem - this.amountExpired)/ this.amountDistribution) * 100).toFixed(2)
      );
      this.expiredPercent = Number(((this.amountExpired / this.amountDistribution)*100).toFixed(2));
      this.availablePercent = Number((100 - this.usedPercent).toFixed(2));
    } else {
      this.usedPercent = 0;
      this.availablePercent = 100;
    }
  }

  onResize(): void {
    this._responsiveService.getMobileStatus().subscribe((isMobile) => {
      this.mobile = isMobile;
    });
    this._responsiveService.checkWidth();
  }

  openDowntimeModal() {
    const dialogRef = this.dialog.open(DowntimeModalComponent, {
      width: "600px",
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.status) {
        this.getRedemptionDowntimeData();
      }
    });
  }

  openConfirmationModal(endNow: boolean) {
    const startDate = this.datePipe.transform(new Date(this.downtimeData.redemptionDowntimeDetails.fromDate), "dd/MM/yyyy");
    const startTime = this.datePipe.transform(new Date(this.downtimeData.redemptionDowntimeDetails.fromDate), "HH:mm");
    const endDate = this.downtimeData.redemptionDowntimeDetails.toDate?this.datePipe.transform(new Date(this.downtimeData.redemptionDowntimeDetails.toDate), "dd/MM/yyyy"):null;
    const endTime = this.downtimeData.redemptionDowntimeDetails.toDate?this.datePipe.transform(new Date(this.downtimeData.redemptionDowntimeDetails.toDate), "HH:mm"):null;
    let dataDialog = {
      title:
        `Would you like to end ${endDate?`the maintenance scheduled until ${endDate} ${endTime}`:`maintenance`}? This will resume redemption services.`,
      img: "../../../../assets/images/redemp-down-end-icon.svg",
      scheduleDowntime: !endNow,
      startDate,
      startTime,
      confirmButton: true,
    };
    // if(!this.startMaintenance){
    if (!endNow) {
      dataDialog.title =
        "Do you want to terminate the maintenance scheduled for";
    }
    const dialogRef = this.dialog.open(DowntimeConfirmationModalComponent, {
      width: "513px",
      data: dataDialog,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.status) {
        let genericDailogData = {
          title: "Success",
          img: "assets/images/n_image/Success.gif",
          heading: "Downtime",
        };
        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
          height: "320px",
          width: "500px",
          data: genericDailogData,
        });
        dialogRef.afterClosed().subscribe(() => {
          this.getRedemptionDowntimeData();
        });
      }
    });
  }
}
